<template>
  <div>
     <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'GatForm',
    props: ['readonly'],
   provide:  function() {
      return {
        getGroupReadonly: ()=>{return this.readonly},
      }
    },
    components: {},
    data: function() {
      return	{
      }
    },


    created(){
    },

    watch:{
    },

    methods:{
    },
  }
</script>

<style scoped>

</style>
